module.exports = __webpack_public_path__ + "media/03.5a214474.mp3";